import { getConfidenceClass } from "../../Document/getConfidenceClass";
import { State } from "../../types";

export type SetConfidenceThresholdAction = Readonly<{
  confidenceThreshold: number;
  type: "SET CONFIDENCE THRESHOLD";
}>;

export const setConfidenceThreshold = (
  state: State,
  action: SetConfidenceThresholdAction,
): State => {
  if (state.confidenceThreshold === action.confidenceThreshold) {
    return state;
  }
  const blocks = Object.keys(state.blocks).reduce((prev, next): State["blocks"] => {
    const block = prev[next];
    if (block.references.length < 1) {
      return prev;
    }
    const newConfidenceClass = getConfidenceClass(block, action.confidenceThreshold, state.values);
    if (newConfidenceClass === block.confidenceClass) {
      return prev;
    }
    if (prev === state.blocks) {
      return {
        ...state.blocks,
        [next]: {
          ...block,
          confidenceClass: newConfidenceClass,
        },
      };
    }
    prev[next] = { ...prev[next], confidenceClass: newConfidenceClass };
    return prev;
  }, state.blocks);
  return {
    ...state,
    blocks,
    confidenceThreshold: action.confidenceThreshold,
  };
};
